import BaseClient from '@/app/model/api/response/baseApiClient'

class UploadLinkImgApi extends BaseClient {
  public uploadLinkImg (data: any) {
    const path = '/v1/file/planting-link-icon'
    const formData = new FormData()
    formData.append('data', data)

    /* 共通処理 */
    return super.donotUseContentType().setBody(formData).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new UploadLinkImgApi()
